import React from "react";
import { Outlet, useRoute, useParams } from "@bcm-dev/bcms-vite";
import "./styles.css";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";

/**
 * @function SecurityTokenPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SecurityTokenPage
 * @example
 * <SecurityTokenPage />
 */
export default function SecurityTokenPage(props) {
  const cardID = useParams().cardID ?? "0";
  const navigate = useRoute();

  return (
    <MainContentContainer 
      className="security-token-page" 
      header={
        <MainContentHeader text="Security Token" onClick={ evt => navigate(`/home/recenttransactions/${ cardID }`) } />
      }>
      
      <Outlet />
    </MainContentContainer>
  );
}